import styled from 'styled-components';

const icon = styled.div`
    font-size: 18px;
    color: ${props => props.theme.callouts.colors.helpicons};
    padding: ${props => props.padding || '5px'};
    transition: all 400ms ease-in-out;
    margin: 0 14px;

    &:hover {
        transform: scale(1.2);
    }
`;

exports.HelpClose = styled(icon).attrs(() => ({
    className: 'icon-close-circle'
}))``;

exports.HelpIcon = styled(icon).attrs(() => ({
    className: 'icon-help-circle'
}))``;



// WEBPACK FOOTER //
// ./src/components/atoms/HelpIcon.js